import { render, staticRenderFns } from "./CashierRobuxElement.vue?vue&type=template&id=6b248011&scoped=true"
import script from "./CashierRobuxElement.vue?vue&type=script&lang=js"
export * from "./CashierRobuxElement.vue?vue&type=script&lang=js"
import style0 from "./CashierRobuxElement.vue?vue&type=style&index=0&id=6b248011&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b248011",
  null
  
)

export default component.exports